// extracted by mini-css-extract-plugin
module.exports = {"block":"FormWeek_block_3XoBl","label":"FormWeek_label_13HWC","error":"FormWeek_error_3faUN","required":"FormWeek_required_1mj4o"};